import React from 'react';
import LegalLayout from '../components/LegalLayout';

export default function Tilmeldingsbetingelser() {
  return (
    <LegalLayout
      title="Medlemsvilkår og bookingbetingelser"
      subtitle="Gældende for medlemmer, Moon Experiences, Moon Gatherings og Moon Treatments hos Moon Yoga."
      path="/tilmeldingsbetingelser"
    >
      <div className="text-xs text-brand-muted mb-6 font-medium">
        Senest opdateret: 29.07.2026
      </div>

      {/* Velkommen */}
      <section className="space-y-3 bg-brand-light-gold/30 border border-brand-primary/10 rounded-2xl p-6 mb-8">
        <h2 className="font-serif text-xl font-semibold text-brand-primary">
          Velkommen
        </h2>
        <p className="text-brand-text leading-relaxed">
          Hos Moon Yoga ønsker vi at skabe et trygt, nærværende og velfungerende fællesskab.
        </p>
        <p className="text-brand-text leading-relaxed">
          Disse medlemsvilkår og bookingbetingelser er udarbejdet for at skabe klare og fair rammer, så både medlemmer og medarbejdere ved, hvad de kan forvente af hinanden.
        </p>
        <p className="text-brand-text leading-relaxed font-medium">
          Ved oprettelse af medlemskab eller køb af en Moon Experience, Moon Treatment eller Moon Gathering accepterer du nedenstående vilkår.
        </p>
      </section>

      {/* 1. Medlemskab */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          1. Medlemskab
        </h2>
        <p>
          Dit medlemskab er personligt og kan ikke overdrages eller deles med andre.
        </p>
        <p>
          Medlemskabet giver adgang til de ydelser, der er inkluderet i det valgte medlemskab.
        </p>
        <p>
          Misbrug af medlemskabet kan medføre øjeblikkelig opsigelse uden varsel.
        </p>
      </section>

      {/* 2. Betaling */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          2. Betaling
        </h2>
        <p>
          Første betaling trækkes ved oprettelse af medlemskabet.
        </p>
        <p>
          Herefter trækkes betalingen automatisk på den aftalte betalingsdato hver måned.
        </p>
        <p>
          Hvis en betaling ikke kan gennemføres, foretages der automatisk op til tre betalingsforsøg.
        </p>
        <p>
          Lykkes betalingen ikke efter tredje forsøg, lukkes adgangen til booking, indtil betalingen er gennemført.
        </p>
        <p>
          Når betalingen registreres, fortsætter medlemskabet automatisk.
        </p>
      </section>

      {/* 3. Opsigelse */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          3. Opsigelse
        </h2>
        <p>
          Medlemskabet kan opsiges via YOGO eller skriftligt til Moon Yoga.
        </p>
        <p>
          Opsigelsesvarslet er løbende måned plus én måned.
        </p>
        <p>
          Bookinger, der ligger efter medlemskabets ophør, annulleres automatisk.
        </p>
        <p>
          Ved varslede prisændringer kan medlemskabet opsiges efter de almindelige opsigelsesregler. Den hidtidige pris fastholdes i hele opsigelsesperioden.
        </p>
      </section>

      {/* 4. Pause */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          4. Pause
        </h2>
        <p>
          Et medlemskab kan sættes på pause én gang pr. kalenderår i op til 90 dage uden beregning.
        </p>
        <p>
          Pausen vælges af medlemmet og kan planlægges op til 30 dage frem.
        </p>
      </section>

      {/* 5. Booking */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          5. Booking
        </h2>
        <p>
          Booking foregår via YOGO.
        </p>
        <p>
          Booking kan foretages inden for den til enhver tid gældende bookingperiode i YOGO.
        </p>
        <p>
          Du kan kun booke hold eller behandlinger, hvis du har et aktivt medlemskab, et gyldigt klippekort eller en Moon Experience.
        </p>
      </section>

      {/* 6. Venteliste */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          6. Venteliste
        </h2>
        <p>
          Hvis et hold er fuldt booket, kan du skrive dig på venteliste.
        </p>
        <p>
          Bliver der en ledig plads, modtager du automatisk besked, hvis du får plads på holdet.
        </p>
        <p>
          Ventelisten slettes 4 timer før holdstart.
        </p>
        <p>
          Bliver der ledige pladser herefter, kan de bookes efter først til mølle-princippet.
        </p>
      </section>

      {/* 7. Afmelding */}
      <section className="space-y-4">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          7. Afmelding
        </h2>
        <p>
          Hvis du bliver forhindret i at deltage, beder vi dig afmelde din plads i god tid. Det giver en anden mulighed for at deltage og hjælper os med at skabe de bedste rammer for alle.
        </p>
        
        <div className="space-y-2 pt-1 pl-2 border-l-2 border-brand-primary/20">
          <h3 className="font-serif font-semibold text-brand-primary">Holdtræning</h3>
          <p>Afmelding skal ske senest 4 timer før holdstart.</p>
        </div>

        <div className="space-y-2 pt-1 pl-2 border-l-2 border-brand-primary/20">
          <h3 className="font-serif font-semibold text-brand-primary">Moon Treatments</h3>
          <p>Afmelding skal ske senest 24 timer før den aftalte behandling.</p>
        </div>

        <div className="space-y-2 pt-1 pl-2 border-l-2 border-brand-primary/20">
          <h3 className="font-serif font-semibold text-brand-primary">Moon Gatherings</h3>
          <p>
            Tilmelding er bindende og kan ikke afbestilles. Du er dog velkommen til at overdrage din plads til en anden. Moon Yoga skal informeres om navneændringen inden arrangementets start.
          </p>
        </div>
      </section>

      {/* 8. No-show */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          8. No-show
        </h2>
        <p>
          Ved manglende eller for sen afmelding til holdtræning opkræves et no-show-gebyr på 48 kr. for medlemmer.
        </p>
        <p>
          Ved udeblivelse eller for sen afmelding til et hold booket med en Moon Experience betragtes oplevelsen som anvendt og kan ikke benyttes på et senere tidspunkt.
        </p>
        <p>
          Ved udeblivelse fra en Moon Treatment eller afmelding senere end 24 timer før behandlingen opkræves det fulde beløb.
        </p>
      </section>

      {/* 9. Aflysninger */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          9. Aflysninger
        </h2>
        <p>
          Vi gør os umage for at gennemføre alle hold, Moon Gatherings og Moon Treatments som planlagt.
        </p>
        <p>
          Moon Yoga forbeholder sig retten til at aflyse et hold ved færre end 2 tilmeldte senest 2 timer før holdstart. Berørte deltagere får besked hurtigst muligt og kan benytte deres medlemskab, klip eller Moon Experience til en anden aktivitet.
        </p>
        <p>
          Ved sygdom eller andre uforudsete forhold kan Moon Yoga indsætte en afløser eller, hvis dette ikke er muligt, aflyse aktiviteten.
        </p>
        <p>
          En afløser er ikke forpligtet til at undervise i samme yogaform som den oprindelige underviser.
        </p>
        <p>
          Moon Yoga forbeholder sig retten til at aflyse et Moon Gathering ved færre end 4 tilmeldte senest 48 timer før start.
        </p>
        <p>
          Ved aflysning tilbydes deltageren enten fuld refundering eller et tilgodebevis.
        </p>
        <p>
          Har et Supermåne-medlem allerede benyttet månedens inkluderede Moon Gathering, tilbydes i stedet deltagelse i et andet Moon Gathering.
        </p>
        <p>
          Ved aflysning af et helt forløb tilbydes fuld refundering, medmindre du ønsker et tilgodebevis.
        </p>
        <p>
          Ved force majeure henvises til Moon Yogas Handels- og forretningsbetingelser.
        </p>
      </section>

      {/* 10. Prisændringer */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          10. Prisændringer
        </h2>
        <p>
          Moon Yoga forbeholder sig retten til at ændre medlemspriser med et varsel på minimum 30 dage.
        </p>
        <p>
          Varsling sker via e-mail eller YOGO.
        </p>
      </section>

      {/* 11. Misbrug */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          11. Misbrug
        </h2>
        <p>
          Hos Moon Yoga ønsker vi at skabe et trygt, respektfuldt og nærværende fællesskab for alle.
        </p>
        <p>
          Moon Yoga forbeholder sig derfor retten til at opsige et medlemskab uden varsel ved væsentligt misbrug.
        </p>
        <p>Dette kan blandt andet omfatte:</p>
        <ul className="list-disc pl-6 space-y-1.5 text-brand-text/90">
          <li>Deling eller overdragelse af medlemskab.</li>
          <li>Misbrug af booking- eller ventelistesystemet.</li>
          <li>Afgivelse af urigtige oplysninger.</li>
          <li>Truende, krænkende eller uacceptabel adfærd over for medlemmer eller medarbejdere.</li>
          <li>Gentagne overtrædelser af disse medlemsvilkår.</li>
        </ul>
        <p>
          Gentagne eller væsentlige overtrædelser af Moon Yogas studieetik kan ligeledes medføre opsigelse af medlemskabet.
        </p>
      </section>

      {/* 12. Studieetik */}
      <section className="space-y-5">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          12. Studieetik
        </h2>
        <p>
          Hos Moon Yoga ønsker vi at skabe et sted, hvor du kan sænke skuldrene, trække vejret dybt og møde dig selv – præcis som du er.
        </p>
        <p>
          Den stemning opstår ikke af sig selv. Den skabes af alle os, der deler rummet.
        </p>
        <p>
          Derfor har vi samlet nogle enkle retningslinjer, som hjælper os med at passe godt på både hinanden og den ro, vi sammen skaber.
        </p>

        <div className="space-y-4 pt-2">
          <div className="space-y-1.5">
            <h3 className="font-serif font-semibold text-brand-primary">Kom gerne lidt før</h3>
            <p>
              Vi anbefaler, at du ankommer 10-15 minutter før holdstart, så du kan lande i ro, finde din plads og begynde din praksis uden hastværk.
            </p>
            <p>
              Er det første gang, du besøger Moon Yoga, er du meget velkommen til at komme cirka 10 minutter før, så vi kan byde dig godt velkommen.
            </p>
            <p>
              Studiet åbner 15-30 minutter før holdstart, og døren låses, når timen begynder, så vi undgår forstyrrelser under undervisningen.
            </p>
          </div>

          <div className="space-y-1.5">
            <h3 className="font-serif font-semibold text-brand-primary">Lad stilheden få plads</h3>
            <p>Vi elsker nærvær og fællesskab.</p>
            <p>
              Inden undervisningen starter, inviterer vi til ro i salen, så alle får mulighed for at lande i deres egen praksis.
            </p>
            <p>
              Efter timen er der altid plads til smil, samtaler og fællesskab i loungeområdet.
            </p>
          </div>

          <div className="space-y-1.5">
            <h3 className="font-serif font-semibold text-brand-primary">Mød dig selv – ikke de andre</h3>
            <p>
              Hos Moon Yoga tror vi ikke på den perfekte yogapraksis.
            </p>
            <p>
              Nogle dage kalder kroppen på styrke. Andre dage på stilhed, hvile eller blot det at være til stede. Begge dele er lige velkomne.
            </p>
            <p>
              Vi kommer alle med forskellige kroppe, forskellige historier og forskellige dage.
            </p>
            <p>
              Lad derfor blikket vende indad frem for udad. Giv slip på sammenligningen, og lad din praksis være præcis den, du har brug for i dag.
            </p>
          </div>

          <div className="space-y-1.5">
            <h3 className="font-serif font-semibold text-brand-primary">Giv slip på hverdagen</h3>
            <p>Sæt gerne din telefon på lydløs eller sluk den helt.</p>
            <p>
              Tasker, sko, mobiltelefoner og andre personlige ejendele bliver uden for salen, så rummet kan opleves roligt og enkelt.
            </p>
          </div>

          <div className="space-y-1.5">
            <h3 className="font-serif font-semibold text-brand-primary">Hjælp os med at passe på studiet</h3>
            <p>
              Når timen er slut, beder vi dig rengøre yogamåtte samt det udstyr, du har brugt og lægge det pænt på plads.
            </p>
            <p>
              Vi ønsker, at alle møder et studie, der føles lige så indbydende, som du selv blev mødt.
            </p>
          </div>

          <div className="space-y-1.5">
            <h3 className="font-serif font-semibold text-brand-primary">Fortæl os, hvis vi skal tage særlige hensyn</h3>
            <p>Giv meget gerne din Moon Teacher besked, hvis:</p>
            <ul className="list-disc pl-6 space-y-1 text-brand-text/90">
              <li>det er din første gang hos Moon Yoga</li>
              <li>du er gravid</li>
              <li>du har en skade eller smerter</li>
              <li>der er andet, vi bør kende til for at støtte dig bedst muligt.</li>
            </ul>
          </div>

          <div className="space-y-1.5">
            <h3 className="font-serif font-semibold text-brand-primary">Påklædning</h3>
            <p>Moon Yoga er et skofrit studie.</p>
            <p>
              Vi anbefaler behageligt tøj, som giver dig frihed til at bevæge dig. Til de rolige hold kan det være rart med en varm trøje og et par strømper til den afsluttende afspænding.
            </p>
            <p>
              Til vores Moon Treatments-sessioner guider vi dig i den påklædning, der passer bedst til behandlingen.
            </p>
          </div>

          <div className="space-y-1.5">
            <h3 className="font-serif font-semibold text-brand-primary">Dufte</h3>
            <p>
              Yoga inviterer os til at være nærværende – også gennem sanserne.
            </p>
            <p>
              Af hensyn til alle beder vi dig derfor undgå kraftig parfume eller andre markante dufte, når du besøger studiet.
            </p>
          </div>

          <div className="space-y-1.5">
            <h3 className="font-serif font-semibold text-brand-primary">Omsorg for hinanden</h3>
            <p>
              Vi deler både rummet og praksissen med hinanden, når vi træner, og de små hensyn gør en stor forskel.
            </p>
            <p>
              Vi er tæt på hinanden under træningen, og derfor beder vi dig være opmærksom på god hygiejne og møde op i rent træningstøj, så det bliver en rar oplevelse for alle.
            </p>
            <p className="font-medium">
              Tak fordi du er med til at skabe et sted, hvor nærvær og omtanke går hånd i hånd.
            </p>
          </div>

          <div className="space-y-1.5">
            <h3 className="font-serif font-semibold text-brand-primary">Lyt til kroppen</h3>
            <p>Du kender din krop bedst.</p>
            <p>
              Vi guider dig gennem praksissen, men opfordrer dig altid til at lytte til kroppens signaler og vælge det, der føles rigtigt for dig.
            </p>
            <p>
              Deltagelse i undervisning og Moon Treatments sker på eget ansvar.
            </p>
            <p className="font-medium pt-2">
              Tak fordi du er med til at passe på Moon Yoga.
            </p>
            <p className="font-medium italic">
              Sammen skaber vi et sted, hvor der er plads til ro, nærvær, bevægelse og mennesker – præcis som de er. 🌙
            </p>
          </div>
        </div>
      </section>

      {/* 13. Holdplan og åbningstider */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          13. Holdplan og åbningstider
        </h2>
        <p>
          Moon Yoga forbeholder sig retten til løbende at tilpasse holdplan, undervisere, åbningstider og udbud af ydelser.
        </p>
        <p>
          Vi bestræber os altid på at informere om ændringer hurtigst muligt.
        </p>
      </section>

      {/* 14. Kontakt */}
      <section className="space-y-3 bg-brand-light-gold/30 border border-brand-primary/10 rounded-2xl p-6">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          14. Kontakt
        </h2>
        <p>
          Har du spørgsmål til dit medlemskab eller disse medlemsvilkår, er du altid velkommen til at kontakte os.
        </p>
        <div className="space-y-1 text-sm font-medium pt-2">
          <p className="font-serif font-semibold text-base">Moon Yoga</p>
          <p>Dalegade 61B</p>
          <p>7000 Fredericia</p>
          <p className="pt-2">
            📧 {' '}
            <a href="mailto:yoga@moonyoga-fredericia.dk" className="text-brand-primary hover:underline">
              yoga@moonyoga-fredericia.dk
            </a>
          </p>
          <p>
            📞 {' '}
            <a href="tel:+4522393836" className="text-brand-primary hover:underline">
              +45 22 39 38 36
            </a>
          </p>
        </div>
      </section>
    </LegalLayout>
  );
}
